import { createContext, useContext } from "react";
import type { User } from "firebase/auth";
import type { PurchasesSession } from "../services/purchasesService";

export type AppBootstrapContextValue = {
  currentUser: User | null;
  authChecked: boolean;
  claimsChecked: boolean;
  claims: Record<string, unknown>;
  isAuthenticated: boolean;
  isAdmin: boolean;
  canAccessTestRaces: boolean;
  raceAccessGeneration: number;
  purchases: PurchasesSession;
  signOut: () => Promise<void>;
  refreshClaims: (forceRefresh?: boolean) => Promise<void>;
};

export const AppBootstrapContext = createContext<AppBootstrapContextValue | null>(null);

/** Public/standalone widgets use an anonymous scope outside the application shell. */
export function useSessionIdentity() {
  const session = useContext(AppBootstrapContext);
  return JSON.stringify([session?.currentUser?.uid, session?.raceAccessGeneration]);
}
